// Crash telemetry: ships client-side errors to the backend so non-reproducible
// bugs (client machines we don't have) leave a stack trace in the server logs.
const BASE_URL = import.meta.env.VITE_API_URL ?? "http://localhost:8000"

let sent = 0
const MAX_PER_SESSION = 5

export function reportClientError(kind: string, message: string, stack?: string | null, componentStack?: string | null) {
  if (sent >= MAX_PER_SESSION) return
  sent++
  const payload = JSON.stringify({
    kind,
    message: String(message).slice(0, 2000),
    stack: (stack ?? "").slice(0, 8000),
    component_stack: (componentStack ?? "").slice(0, 4000),
    url: window.location.href,
    user_agent: navigator.userAgent,
    tenant: localStorage.getItem("tenant_name"),
    user: localStorage.getItem("user_email"),
    ts: new Date().toISOString(),
  })
  try {
    // sendBeacon survives page unload/reload (the user clicking "Recharger la page")
    if (!navigator.sendBeacon?.(`${BASE_URL}/system/client-error`, new Blob([payload], { type: "application/json" }))) {
      void fetch(`${BASE_URL}/system/client-error`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true })
    }
  } catch { /* never break the app over telemetry */ }
}

export function installGlobalErrorReporting() {
  window.addEventListener("error", e => {
    reportClientError("window.onerror", e.message, e.error?.stack)
  })
  window.addEventListener("unhandledrejection", e => {
    const r = e.reason
    reportClientError("unhandledrejection", r?.message ?? String(r), r?.stack)
  })
}
